// extracted by mini-css-extract-plugin
export default {"testimonials":"Testimonials_testimonials__Jmf3j","content":"Testimonials_content__p-y1n"};